import { Box, MenuItem, Typography } from "@mui/material";

import React from "react";
import i18next from "i18next";

const LanguageHolderItem = (props) => {
  const { handleClose, title, icon, language } = props || {};

  const handleCloseFunction = () => {
    handleClose();
    i18next.changeLanguage(language);
  };
  return (
    <MenuItem onClick={handleCloseFunction}>
      <Box display="flex" alignItems="center">
        <img src={icon} alt="USA Flag" style={{ width: 20, marginRight: 10 }} />
        <Typography>{title}</Typography>
      </Box>
    </MenuItem>
  );
};

export default LanguageHolderItem;
